/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import FilterComponent from "./FilterComponent";
import Button from '@mui/material/Button';

const Test = (props) => {
    const [dataColumns, setDataColumns] = useState([]);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    useEffect(() => {
        let columns = [];
        if (props.data.length !== 0) {
            let rowsCont = 0;
            Object.entries(props.data[0]).forEach(([key, value]) => {
                if (key !== "id") {
                    let dataColumn = {};
                    dataColumn = {
                        name: key,
                        selector: row => row[key],
                        sortable: true,
                    }
                    columns[rowsCont] = dataColumn;
                    rowsCont++;
                    if (props.handledEdit || props.handledDelete || props.handledSee || props.handledSend)
                        if (Object.keys(props.data[0]).length === (rowsCont + 1)) {
                            dataColumn = {
                                name: 'Acciones',
                                cell: row => (
                                    <>
                                        {
                                            props.handledEdit
                                                ?
                                                <button onClick={(e) => props.handledEdit(row.id)} className="btn btn-xs btn-success">
                                                    <i className="nav-icon fas fa-edit"> </i>
                                                </button>
                                                :
                                                ""
                                        }
                                        
                                        {
                                            props.handledDelete
                                                ?
                                                <>&nbsp;&nbsp;
                                                <button href="!#" onClick={(e) => props.handledDelete(row.id)} id={row.codigo} className="btn btn-xs btn-danger">
                                                    <i className="nav-icon fas fa-trash"></i>
                                                </button>
                                                </>
                                                :
                                                ""
                                        }
                                        
                                        {
                                            props.handledSee
                                                ?
                                                <>&nbsp;&nbsp;
                                                <button href="!#" onClick={(e) => props.handledSee(row.id)} id={row.codigo} className="btn btn-xs btn-success">
                                                    <i className="nav-icon fas fa-eye"></i>
                                                </button>
                                                </>
                                                :
                                                ""
                                        }
                                       
                                        {
                                            props.handledSend
                                                ?
                                                <>&nbsp;&nbsp;
                                                <button href="!#" onClick={(e) => props.handledSend(row.id)} id={row.codigo} className="btn btn-xs btn-info">
                                                    <i className="nav-icon fas fa-envelope"></i>
                                                </button>
                                                </>
                                                :
                                                ""
                                        }
                                        
                                        {
                                            props.handledEditAccess
                                                ?
                                                <>&nbsp;&nbsp;
                                                <button href="!#" onClick={(e) => props.handledEditAccess(row.id)} id={row.codigo} className="btn btn-xs btn-info">
                                                    <i className="nav-icon fas fa-list"></i>
                                                </button>
                                                </>
                                                :
                                                ""
                                        }
                                    </>
                                ),
                            }
                            columns[rowsCont] = dataColumn;
                            rowsCont++;

                        }
                }
            });
        }
        setDataColumns(columns)
    }, [props]);

    const filteredItems = props.data.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const downloadCSV = (array) => {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(array);
        if (csv == null) return;

        const filename = 'export.csv';

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }

        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }

    function convertArrayOfObjectsToCSV(array) {
        let result;

        const columnDelimiter = ',';
        const lineDelimiter = '\n';
        if (typeof filteredItems[0] !== "undefined") {
            const keys = Object.keys(filteredItems[0]);

            result = '';
            result += keys.join(columnDelimiter);
            result += lineDelimiter;

            array.forEach(item => {
                let ctr = 0;
                keys.forEach(key => {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];

                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }
    }

    const Export = ({ onExport }) => <Button variant="outlined" onClick={e => onExport(e.target.value)}>Descargar   <>&nbsp;&nbsp;</><i className='fas fa-download'></i></Button>;

    const actionsMemo = React.useMemo(() => <Export onExport={() => downloadCSV(filteredItems)} />, []);

    return (
        <div>

            <DataTable
                title={props.title}
                columns={dataColumns}
                data={filteredItems}
                pagination
                subHeader
                actions={actionsMemo}
                subHeaderComponent={subHeaderComponent}
            />
        </div>
    )

}

export default Test


